import i18n from "i18next"
import backend from "i18next-http-backend"
import { initReactI18next } from "react-i18next"

i18n
  .use(backend)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    languages: ["en", "fr"],
    ns: ["translation"],
    defaultNS: "translation",
    debug: false,
    keySeparator: ">",
    nsSeparator: "|",
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?20260819`
    }
  })

export default i18n